import React from 'react'
import Column from './Column'
import FooterPosts from './FooterPosts'
import * as Styles from './ColumnsWrapper.module.css'

const ColumnsWrapper = ({ data = {} }) => {
  return (
    <div className={Styles.columns}>
      <Column
        className="col-span-2"
        heading="LeadBoxer"
        items={data.footer.menuItems.nodes}
      />

      <Column
        className="col-span-4"
        heading="Integrations"
        innerColumns={2}
        items={data.integrations.nodes}
      />

      <Column
        className="col-span-2"
        heading="Support"
        items={data.support.menuItems.nodes}
      />

      <FooterPosts heading="Latest Articles" posts={data.allWpPost.nodes} />
    </div>
  )
}

export default ColumnsWrapper
